import React, { useContext } from 'react'
import { Field, Form, Formik } from 'formik';
import ValidationError from '../components/Errors/ValidationError';
import { getImages } from '../components/Common/const';
import { VehicleContext } from '../components/Context/VehicleContext';
import { useNavigate } from 'react-router-dom';

const Contact = () => {

    const {submitContactForm} = useContext(VehicleContext);

    const navigate = useNavigate();
    
    return (
        <>
            <section className='contact-wrap common-wrap'>
                <div className='container'>
                    <div className='contact-block'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='lg-title mb-2 text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Contact Us</div>
                                <div className='sm-title cw-sub-title wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Drop us a line, we'd love to hear from you</div>
                                <div className='cl-box mt-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.4s">
                                    <div className='sm-title text-uppercase text-blue mb-3 fw-500 font-24'>Boerne</div>
                                    <div className='mb-2 pb-1'>
                                        <a href='tel:8309815050' className='xs-title text-white font-19'>
                                            <span className='call-icon me-3'><img src={getImages('call.png')} alt='call'/></span> 
                                            830-981-5050
                                        </a>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <a href='https://maps.app.goo.gl/U2PATXtey8ubCbR67' target='_blank' className='xs-title text-white fw-400 d-flex align-items-center'>
                                            <i className="bi bi-geo-alt-fill text-blue envelope-text me-3"></i> 
                                            <span>140 Enterprise Parkway Boerne, TX 78006</span>
                                        </a>
                                        <a href='https://maps.app.goo.gl/U2PATXtey8ubCbR67' target='_blank' className='map-it-btn text-blue xs-title fw-400'>MAP IT</a>
                                    </div>
                                </div>
                                <div className='cl-box mt-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                                    <div className='sm-title text-uppercase text-blue mb-3 fw-500 font-24'>Austin</div>
                                    <div className='mb-2 pb-1'>
                                        <a href='tel:5122337800' className='xs-title text-white font-19'>
                                            <span className='call-icon me-3'><img src={getImages('call.png')} alt='call'/></span> 
                                            512-233-7800
                                        </a>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <a href='https://maps.app.goo.gl/bYkpQSc6S9KBdW26A' target='_blank' className='xs-title text-white fw-400 d-flex align-items-center'>
                                            <i className="bi bi-geo-alt-fill text-blue envelope-text me-3"></i> 
                                            <span>2301 Double Creek Dr #270, Round Rock, TX 78664</span>
                                        </a>
                                        <a href='https://maps.app.goo.gl/bYkpQSc6S9KBdW26A' target='_blank' className='map-it-btn text-blue xs-title fw-400'>MAP IT</a>
                                    </div>
                                </div>
                                <div className='text-center mt-5 mm-logo d-none d-md-block'>
                                    <img src={getImages('mm-logo-white.png')}/>
                                </div>
                            </div>
                            <div className='col-md-6 pt-3 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                                <Formik
                                    // validationSchema={validationSchema}
                                    initialValues={{
                                        full_name: '',
                                        email: '',
                                        phone: '',
                                        comment: '',
                                        location: 'boerne',
                                    }}
                                    onSubmit={async (values, { resetForm }) => {
                                        console.log(values);
                                        const data = await submitContactForm(values);
                                        if (data.success) {
                                            resetForm();
                                            navigate("/thank-you");
                                        } else
                                            alert("There was a problem with your submission");
                                    }}
                                >
                                    {({ values, setFieldValue, field, form }) => (
                                        <Form className="custom-form contact-form" autoComplete="off" name="contact-form">
                                            <div className='form-group'>
                                                <div className='cs-label mb-3 font-1-5em'>Select Location</div>
                                                <div className="custom-radio-group mb-4">
                                                    <label className="custom-radio">
                                                        <Field type="radio" name="location" value="boerne" />
                                                        <span></span>
                                                        Boerne
                                                    </label>
                                                    <label className="custom-radio">
                                                    <Field type="radio" name="location" value="austin" />
                                                    <span></span>
                                                    Austin
                                                    </label>
                                                </div>
                                                <ValidationError name="location" />
                                            </div>

                                            <div className='form-group'>
                                                <div className='cs-label mb-2'>Full Name</div>
                                                <Field
                                                    type="text"
                                                    name="full_name"
                                                    className="form-control"
                                                    required />
                                                <ValidationError name="full_name" />
                                            </div>
                                            <div className='form-group'>
                                                <div className='cs-label mb-2'>Email</div>
                                                <Field
                                                    type="text"
                                                    name="email"
                                                    className="form-control"
                                                    required />
                                                <ValidationError name="email" />
                                            </div>
                                            <div className='form-group'>
                                                <div className='cs-label mb-2'>Phone Number</div>
                                                <Field
                                                    type="text"
                                                    name="phone"
                                                    className="form-control"
                                                    required />
                                                <ValidationError name="phone" />
                                            </div>
                                            <div className='form-group'>
                                                <div className='cs-label mb-2'>Comments</div>
                                                <Field
                                                    type="text"
                                                    name="comment"
                                                    className="form-control h-218"
                                                    component="textarea" />
                                                <ValidationError name="comment" />
                                            </div>
                                            <button type='submit' className='btn-theme lg-btn w-100 mt-3'>Send</button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                        <div className='text-center mt-5 mm-logo d-md-none'>
                            <img src={getImages('mm-logo-white.png')}/>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact